import get from 'lodash/get';
import { createSelector } from 'reselect';
import { reduxKey } from './constants';
import { denormalize } from '../normalizr';
export var getDataEntities = function (state) { var _a; return (_a = state[reduxKey]) !== null && _a !== void 0 ? _a : {}; };
export var getDataEntityById = function (state, entitySchema, id) {
    var entities = getAllDataEntitiesForSchema(state, entitySchema);
    if (entities) {
        return entities[id];
    }
};
export var getDataEntitiesByIds = function (state, entitySchema, ids) {
    var entities = getAllDataEntitiesForSchema(state, entitySchema);
    if (entities) {
        return ids.map(function (id) { return entities[id]; }).filter(function (entity) { return !!entity; });
    }
    return [];
};
export var getAllDataEntitiesForSchema = function (state, entitySchema) { return get(state, "".concat(reduxKey, ".").concat(entitySchema.key)); };
export var getAllDataEntitiesForSchemaArray = function (state, entitySchema) {
    var entities = getAllDataEntitiesForSchema(state, entitySchema) || {};
    return Object.keys(entities).map(function (key) { return entities[key]; });
};
/**
 * Important! Do not use any Denormalized selectors for components
 * It will cause re-rendering, because will be not optimized for reselect
 */
export var getDenormalizedDataEntityById = function (state, entitySchema, id) { return denormalize(id, entitySchema, state[reduxKey]); };
export var getAllDenormalizedDataEntitiesForSchema = function (state, entitySchema /* should be schema.Entity, but even though schema.Entity has isAttribute, it is not a part of the interface. Sadface. */) {
    return denormalize(Object.keys(get(state, "".concat(reduxKey, ".").concat(entitySchema.key), {})), [entitySchema], get(state, reduxKey)).reduce(function (result, entity) {
        // key by idAttribute
        var idAttribute = typeof entitySchema.idAttribute === 'function'
            ? 'id'
            : entitySchema.idAttribute;
        result[entity[idAttribute]] = entity;
        return result;
    }, {});
};
export var createGetDenormalizedDataEntitiesByIds = function () {
    return createSelector([
        function (state, entitySchema, ids) {
            return getAllDenormalizedDataEntitiesForSchema(state, entitySchema);
        },
        function (state, entitySchema, ids) {
            return ids;
        },
    ], function (allEntitiesKeyedByIds, ids) {
        return ids.map(function (id) { return allEntitiesKeyedByIds[id]; }).filter(function (i) { return i !== undefined; });
    });
};
export var getDenormalizedDataEntitiesByIds = createGetDenormalizedDataEntitiesByIds();
//# sourceMappingURL=selectors.js.map